import { Navigate, useRoutes } from 'react-router-dom';
import { getPathAfterLogin } from 'src/layouts/dashboard/config-navigation';
import { mainRoutes } from './main';

import { authRoutes } from './auth';
import { bundleRoutes } from './budle';
import { b2bRoutes } from './b2b';
import { subscriptionRoutes } from './subscription';
import { customersRoutes } from './customer';
import { changeLogRoutes } from './changeLog';
import { vendorActivationsRoutes } from './vendorActivitions';
import { cancellationScheduleRoutes } from './cancellationSchedule';
import { roleRoutes } from './role';
import { internalUserRoutes } from './internalUser';
import { ApiCertificationRoutes } from './apiCertifications';
import { healthRoute } from './health';
import { downgradeScheduleRoutes } from './downgradeSchedule';
import { customerBlacklistRoutes } from './customerBlacklist';
import {netflixInitiatedChangesRoutes} from './netflixInitiatedChanges'
import { setantaActivationsRoutes } from './setantaActivations';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: <Navigate to={getPathAfterLogin() || '/auth/login'} replace />,
    },

    // Auth routes
    ...authRoutes,

    // Customers routes
    ...customersRoutes,

    // Bundle routes
    ...bundleRoutes,

    // B2B routes
    ...b2bRoutes,

    // Subscription routes
    ...subscriptionRoutes,

    // ChangeLog routes
    ...changeLogRoutes,

    // VendorActivations routes
    ...vendorActivationsRoutes,

    // SetantaActivations routes
    ...setantaActivationsRoutes,

    //   CancellationSchedule routes
    ...cancellationScheduleRoutes,

    //   DowngradeSchedule routes
    ...downgradeScheduleRoutes,

    // CustomerBlacklist routes
    ...customerBlacklistRoutes,

    // netflixInitiatedChanges routes
    ...netflixInitiatedChangesRoutes,

    // Role routes
    ...roleRoutes,

    // InternalUser routes
    ...internalUserRoutes,

    // ApiCertification routes
    ...ApiCertificationRoutes,

    // Main routes
    ...mainRoutes,

    // Health routes
    ...healthRoute,


    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
